export class CachedPreviewImage {
    imageURL: string;
    imageBlob: Blob;
    valid: boolean = true;

    constructor(imageBlob:Blob) {
        this.imageURL = URL.createObjectURL(imageBlob);
        this.imageBlob = imageBlob;
    }
}